module.exports = {
    /*pillsSizeType: {
        PILLS_SIZE_TYPE_SMALL: 'pillsSizeTypeSmall',
        PILLS_SIZE_TYPE_BIG: 'pillsSizeTypeBig',
    },*/

    pillsViewType: {
        PILLS_VIEW_TYPE_COLORED: 'pillsViewTypeColored',
        PILLS_VIEW_TYPE_COLORED_LIGHT: 'pillsViewTypeColoredLight',
        PILLS_VIEW_TYPE_WHITE: 'pillsViewTypeWhite'
    },

    /*pillsColorType: {
        PILLS_COLOR_TYPE_PROJECT: 'pillsColorTypeProject',
        PILLS_COLOR_TYPE_STATUS: 'pillsColorTypeStatus',
    },*/

    pillsTitleType: {
        PILLS_TITLE_TYPE_TITLE              : 'pillsTitleTypeTitle',
        PILLS_TITLE_TYPE_PROJECT_TITLE      : 'pillsTitleTypeProjectTitle',
        PILLS_TITLE_TYPE_FULL_PATH_TITLE    : 'pillsTitleTypeFullPathTitle',
        PILLS_TITLE_TYPE_PROJECT            : 'pillsTitleTypeProject',
        PILLS_TITLE_TYPE_FULL_PATH          : 'pillsTitleTypeFullPath',
    },

    pillsHeightType: {
        PILLS_HEIGHT_TYPE_DEFAULT: 'default',
        PILLS_HEIGHT_TYPE_VIEW: 'view',
        PILLS_HEIGHT_TYPE_BIG: 'big-height',
    },

    eventsFilter: {
        PERSONAL_VACATION: 'personal_vacation',
        PERSONAL_SICK: 'personal_sick',
        PERSONAL_TRAVEL: 'personal_travel',

        ORGANIZATION_HOLIDAY: 'organization_holiday',
        ORGANIZATION_EVENT: 'organization_event',

        PROJECT_MILESTONE: 'project_milestone',
        PROJECT_EVENT: 'project_event',
    },

    viewType: {
        DEFAULT: 'default',
        MY_WORK: 'my-work'
    },

    groupMode: {
        NONE: 'none',
        PRIORITY: 'priority',
        FOLDER: 'folder',
        SUBFOLDER: 'subfolder'
    },

    NOT_ASSIGNED_ROW_ID: 'not-assigned',

    timeAllocation: {

        // see enum TIME_DISTRIBUTION
        distributionMode: {
            AUTO: 'auto',
            MANUAL: 'manual',
            WORKDAY_BASED: 'workday_based'
        },

        distributionModeLabel: {
            'auto': 'Auto',
            'manual': 'Manual',
            'workday_based': 'Workday'
        },

        distributionModeIcon: {
            'auto': 'i5-workload-auto',
            'manual': 'i5-workload-manual',
            'workday_based': 'i5-workday-percent'
        },

        autoDistributionType: {
            EVENLY: 'auto_evenly',
            FRONT_LOAD: 'auto_front_load',
            BACK_LOAD: 'auto_back_load',
            // FULL_TIME: 'auto_full_time'
        },

        autoDistributionTypeLabel: {
            'auto_evenly': 'Evenly',
            'auto_front_load': 'Front load',
            'auto_back_load': 'Back load',
            // 'auto_full_time': 'Full day'
        },

        autoDistributionTypeIcon: {
            'auto_evenly': 'i5-evenly',
            'auto_front_load': 'i5-front-load',
            'auto_back_load': 'i5-back-load',
            // 'auto_full_time': 'i5-full-day'
        },
    },

    viewScale: {
        WEEKLY: 'allocation_weekly',
        DAILY:  'allocation_daily'
    },

    groupByCriteria: {
        ASSIGNED_TO: 'assigned-to',
        PROJECT:     'project',
        NONE:        'none'
    },

    // deprecated - use enum !
    summaryMode: {
        HOURS           : 'summary_hours',
        TASKS           : 'summary_tasks',
        STORY_POINTS    : 'summary_story_points'
    }
};